import * as React from 'react';

export function asyncComponent(importComponent: any, key = 'default') {
  return React.lazy(async () => {
    const res = await importComponent();
    const Component = res[key];
    return {default: Component};
  });
}
